import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import LinearProgress, { LinearProgressProps } from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import { ReactComponent as GreenTickIcon } from "./assets/icons/greenTickIcon.svg"

const useStyles = makeStyles({
    root: {
        display: "inline-block",
        width: 164,
        right: 28,
        bottom: 26,
        position: "absolute",

        "& .linearBarSurround": {
            width: 100,
            margin: 0
        },
        "& .greenTickIcon": {
            width: 16,
            height: 16,
            marginTop: 1,
            position: "absolute",
            right: 0,
            bottom: 2
        },
        "& .label": {
            fontSize: 12,
            marginRight: 7
        },
        "& .largeLabel": {
            fontSize: 16,
            width: "auto",
            position: "absolute",
            right: 25,
            bottom: 0
        },
        "& .label, & .largeLabel": {
            color: "#ccc"
        },
        "& .MuiLinearProgress-determinate": {
            height: 6,
            width: 100,
            borderRadius: 35,
        },
        "& .MuiLinearProgress-colorPrimary": {
            background: "#e8e8e8"
        },
        "& .MuiLinearProgress-barColorPrimary": {
            background: "#9be169"
        }
    },
});

function LinearProgressWithLabel(props: LinearProgressProps & { value: number, fileSize: number, progress: number, uploaded: boolean }) {
    return (
        <Box display="flex" alignItems="center">
            {props.progress < 100 ? (
                <>
                    <Box minWidth={35} className="label">
                        <span>Uploading</span>
                    </Box>
                    <Box width="100%" mr={1} className="linearBarSurround">
                        <LinearProgress variant="determinate" {...props} />
                    </Box>
                </>
            ) : (
                    <>
                    { props.uploaded ?
                        (<>
                            <Box className="largeLabel">
                                <span>{props.fileSize}kb</span>
                            </Box>
                            <GreenTickIcon className="greenTickIcon" />
                        </>) : null
                    }
                    </>
                )}
        </Box>
    );
}

export default function APLoadingProgress(props: any) {
    const classes = useStyles();
    const [progress, setProgress] = React.useState(10);

    React.useEffect(() => {
        const timer = setInterval(() => {
            setProgress((prevProgress) => (prevProgress >= 90 ? 90 : prevProgress + 10));
        }, 50);
        
        return () => {
            clearInterval(timer);
        };
    }, []);

    return (
        <div className={classes.root}>
            <LinearProgressWithLabel value={props.uploaded ? 100 : progress} fileSize={props.fileSize} progress={props.uploaded ? 100 : progress} uploaded={props.uploaded} />
        </div>
    );
}